const quizState = {
  title: 'Quiz title',
  description: 'Choose the best option',
  engagementData: {
    engagementType: 'quiz',
    engagementTemplate: 'default',
    showAnswer: true,
    options: [
      { title: '', isAnswer: false },
      { title: '', isAnswer: false },
    ],
  },
};

export default quizState;
